import {
    EDIT_CUSTOMERS_FAILED,
    EDIT_CUSTOMERS_LOADING,
    EDIT_CUSTOMERS_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editCustomerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case EDIT_CUSTOMERS_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_CUSTOMERS_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.payload,
        };
      case EDIT_CUSTOMERS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
     
      default:
        return state;
    }
  };
  